<template>
  <div id="app">
    <!-- <vue-scroll style="height: 100vh;" @handle-scroll="handleScroll" ref="vscroller" > -->
    <router-view />
    <!-- </vue-scroll> -->
    <!-- <Chat ></Chat> -->
  </div>
</template>

<script>
import bus from '@/util/bus.js'
// import Chat from '@/components/Chat.vue'
import { getQueryVariable } from '@/util'
import { loadScript } from '@/util/index'
import { guid } from '@/util/uuid'
import { isInViewport } from '@/util/isInViewport'
import _ from 'lodash'

export default {
  // components: { Chat },
  created() {
    this.reportSetSession()
    this.initLanguage()
    this.loadVconsole()
  },
  mounted() {
    this.saveReferrer()
    this.saveInvitationCode()
    this.windowOnResize()
    this.listenerVisibilitychange()
    this.listenerScroll()
    // this.listenerClick()

    // 别删，有用
    setTimeout(this.mobileRemoveBigChatDiv, 200)
    setTimeout(this.mobileRemoveBigChatDiv, 500)
    setTimeout(this.mobileRemoveBigChatDiv, 900)
  },
  activated() {
  },
  methods: {
    /**
     * 监听页面隐藏显示
     */
    listenerVisibilitychange() {
      // 页面更新前
      window.onbeforeunload = () => {
        this.$record({
          eventType: 'refresh',
          eventId: `${this.$route.meta.pageId}_refresh`
        })
      }

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          this.$record({
            eventType: 'hide',
            eventId: `${this.$route.meta.pageId}_hide`
          })
        } else if (document.visibilityState === 'visible') {
          this.$record({
            eventType: 'show',
            eventId: `${this.$route.meta.pageId}_show`
          })
        }
      })
    },

    /**
     * 监听滚动条事件
     */
    listenerScroll() {
      window.addEventListener('scroll', () => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let is_top = scrollTop <= 0
        if (this.$showAdvertis && this.$store.state.isShowAdvertis !== is_top) {
          this.$store.commit('setShowAdvertis', is_top)
        }

        kakaScroll()

        kakaExposure()
      })

      // 滚动条操作时 发送操作埋点
      const kakaScroll = _.debounce(() => {
        this.$record({
          eventType: 'scroll',
          eventId: `${this.$route.meta.pageId}_scroll`
        })
      }, 800, { leading: true, trailing: false })

      // 监听视口可见曝光
      const kakaExposure = _.debounce(() => {
        let arr = []
        document.querySelectorAll('.kakaExposure').length && document.querySelectorAll('.kakaExposure').forEach(item => {
          if (isInViewport(item)) {
            let paramObj = {}
            for (let key in item.dataset) {
              if (key.includes('exposure') || key.includes('type')) {
                if (key === 'exposureLocation') {
                  paramObj[key] = `${this.$route.meta.pageId}_${item.dataset[key]}`
                } else paramObj[key] = item.dataset[key]
              }
            }
            arr.push(paramObj)
          }
        })
        if (!arr.length) return
        this.$record({
          eventType: 'exposure',
          eventId: `${this.$route.meta.pageId}_exposure`,
          value: JSON.stringify(arr)
        })
      }, 800, { leading: false, trailing: true })
    },

    /**
     * 埋点session存储
     */
    reportSetSession() {
      if (!sessionStorage.getItem('kk_sessionId')) {
        sessionStorage.setItem('kk_sessionId', guid())
      }
      sessionStorage.setItem('kk_pageRequestId', `PRId${new Date().getTime()}`)
    },

    handleScroll(vertical, horizontal, nativeEvent) {
      bus.$emit('scroll', vertical, horizontal, nativeEvent)
    },
    /**
     * 初始化语种
     */
    initLanguage() {
      const lang = this.$store.state.language
      if (lang) this.$i18n.locale = lang
    },
    /**
     * 保存网盟邀请码
     */
    saveInvitationCode() {
      const promotionCode = getQueryVariable('code') // 推广码
      const promotionSource = getQueryVariable('from') || '' // 来源自哪个平台
      if (promotionCode) this.$store.commit('common/set', { promotionCode, promotionSource })
    },
    /**
     * 监听浏览器窗口大小改变
     */
    windowOnResize() {
      // this.$store.commit('set', {
      //   isPC: screen.width > 1000
      // })
      window.addEventListener('resize', this.resizeCallBack)
      // this.resizeCallBack()
    },
    /**
     * 监听浏览器窗口大小改变回调函数
     */
    resizeCallBack() {
      this.$store.commit('set', {
        isPC: document.body.offsetWidth > 1000
      })
    },
    /*
     * 保存来源信息，用于数据埋点
     */
    saveReferrer() {
      const referrer = document.referrer
      const hostname = location.hostname
      const localStorageReferrer = localStorage.getItem('referrer')
      // 不记录本网站
      if (referrer.includes(hostname)) return
      if (localStorageReferrer && localStorageReferrer.includes(hostname)) localStorage.removeItem('referrer')
      if (referrer) localStorage.setItem('referrer', referrer)
    },
    /**
     * livechat插件在移动端会遮挡其它元素，影响操作
     * 这个代码看上去很蠢，但这是必须的
     */
    mobileRemoveBigChatDiv() {
      try {
        const elList = document.querySelectorAll('body>#chat-widget-container')
        if (elList.length === 2) {
          document.body.removeChild(elList[0])
        }
        // document.querySelectorAll('body>#chat-widget-container').forEach(el => {
        //   if (el.offsetHeight > 250) {
        //     document.body.removeChild(el)
        //   }
        // })
      } catch (error) {
        console.log(error)
      }
    },
    loadVconsole() {
      if (process.env.NODE_ENV === 'production' || this.isPC) return
      loadScript('https://cdn.bootcss.com/vConsole/3.3.0/vconsole.min.js', () => {
        window.VConsole && new window.VConsole()
      })
    }
  }
}
</script>

<style>
@import './assets/css/common.css';
@import './assets/css/elementCustom.css';
@import './assets/css/mobile.css';
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body {
  font-family: 'Poppins', 'PingFang SC', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif' !important;
  background: #f5f7f7;
  font-size: 14px;
}
.main {
  max-width: 1200px;
  margin: 0 auto;
}
.backtop {
  width: 65px !important;
  height: 65px !important;
  box-shadow: unset !important;
  background-color: unset !important;
}

/* el-select 组件将默认样式改为圆角 */
.el-input.el-input--suffix > .el-input__inner,
.el-input > .el-input__inner {
  border-radius: 100px;
}
.el-table .has-gutter th.el-table__cell {
  background: rgba(0, 0, 0, 0.02);
}
.el-table .has-gutter th.el-table__cell .cell {
  color: #10141d;
  font-size: 14px;
  font-weight: 500;
}
.el-popconfirm__main {
  margin: 1em 0;
}
/* .el-message{
  z-index: 2002!important;
} */
/* 客服聊天icon 层级 */
#chat-widget-container {
  z-index: 2000 !important;
}

/* 空中云汇第三方页面层级提升 */
#threeDsChallenge {
  z-index: 3000 !important;
}
</style>
